<template>
  <organism-create-edit-commands
    :originAutoBackupConfig="autoBackupConfigDetail"
    @onRequestCreateNewAutoBackupConfig="onRequestCreateNewAutoBackupConfig"
    @onRequestSaveChangesAutoBackupConfig="onRequestSaveChangesAutoBackupConfig"
    @onRequestDeleteAutoBackupConfig="onRequestDeleteAutoBackupConfig"
  ></organism-create-edit-commands>
</template>

<script>
import OrganismCreateEditCommands from "@/components/organisms/networkConfigurationManagement/backupSettings/OrganismCreateEditCommands.vue"
import {
  createNewAutoBackupConfig,
  deleteAutoBackupConfig,
  editAutoBackupConfig,
  getAutoBackupConfigDetailById,
} from "@/api/api-module4"
import mixins from "@/mixins"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "CreateEditCommands",
  components: {
    OrganismCreateEditCommands,
  },
  mixins: [mixins, mixinsValidator],
  data() {
    return {
      autoBackupConfigDetail: null,
    }
  },
  computed: {
    autoBackupConfigId() {
      return this.$route?.params?.id
    },
  },
  watch: {
    autoBackupConfigId: {
      immediate: true,
      handler() {
        if (this.hasString(this.autoBackupConfigId)) {
          this.getAutoBackupConfigDetailFromApi()
        }
      },
    },
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path)
    },

    onRequestCreateNewAutoBackupConfig(autoBackupConfigData) {
      this.sendRequestCreateNewAutoBackupConfigToApi(autoBackupConfigData)
    },

    onRequestSaveChangesAutoBackupConfig(
      autoBackupConfigId,
      autoBackupConfigData
    ) {
      this.sendRequestEditAutoBackupConfigToApi(
        autoBackupConfigId,
        autoBackupConfigData
      )
    },

    onRequestDeleteAutoBackupConfig(autoBackupConfigId) {
      this.sendRequestDeleteAutoBackupConfigToApi(autoBackupConfigId)
    },

    async getAutoBackupConfigDetailFromApi() {
      this.showLoading(true)
      await getAutoBackupConfigDetailById(this.autoBackupConfigId)
        .then((response) => {
          if (response) {
            this.autoBackupConfigDetail = {
              autoBackupConfigId: response.data.autoBackupConfigId,
              autoBackupConfigName: response.data.autoBackupConfigName,
              autoBackupConfigDescription:
                response.data.autoBackupConfigDescription,
              isForCiscoDevice: response.data.isForCiscoDevice,
              commands: response.data.commands.map((command) => {
                return {
                  command: command.command,
                  prompt: command.prompt,
                  timeout: String(command.timeout),
                  backupResponse: command.backupResponse,
                }
              }),
            }
          }
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestCreateNewAutoBackupConfigToApi(autoBackupConfigData) {
      this.showLoading(true)
      await createNewAutoBackupConfig(autoBackupConfigData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Created Successfully")
            this.navigateTo("/network-configuration/backup-settings")
          } else {
            this.toastError("Create Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestEditAutoBackupConfigToApi(
      autoBackupConfigId,
      autoBackupConfigData
    ) {
      this.showLoading(true)
      await editAutoBackupConfig(autoBackupConfigId, autoBackupConfigData)
        .then((response) => {
          if (response) {
            this.toastSuccess("Saved Successfully")
            this.navigateTo("/network-configuration/backup-settings")
          } else {
            this.toastError("Save Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async sendRequestDeleteAutoBackupConfigToApi(autoBackupConfigId) {
      this.showLoading(true)
      await deleteAutoBackupConfig(autoBackupConfigId)
        .then((response) => {
          if (response) {
            this.toastSuccess("Deleted Successfully")
            this.$router.go()
          } else {
            this.toastError("Delete Failed")
          }
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
